import { BigNumber } from '@0x/utils'
import { Asset } from 'app-lib/assetUtils'
import { ChainId } from 'bzx-common/src/config/appConfig'

export default class StakeEvent {
  public static readonly topic0: string =
    '0xc5017594d2723c038bb216e5bcef3ac65910ade839c0e63253bf5b59efbf0fd7'
  public readonly chainId: ChainId = 1
  public readonly user: string //indexed
  public readonly amount: BigNumber
  public readonly token: Asset
  public readonly blockNumber: BigNumber
  public readonly txHash: string
  public readonly timestamp: Date

  constructor(
    user: string,
    token: Asset,
    amount: BigNumber,
    blockNumber: BigNumber,
    txHash: string,
    timestamp: Date
  ) {
    this.user = user
    this.token = token
    this.amount = amount
    this.blockNumber = blockNumber
    this.txHash = txHash
    this.timestamp = timestamp
  }
}
